/** Shared USD formatter. */
const USD = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

/**
 * Format an amount as USD for display.
 * @example
 * formatCurrency(1234.5)               // => "$1,234.50"
 * formatCurrency("1234.5")             // => "$1,234.50"
 * formatCurrency(0)                    // => "$0.00"
 * formatCurrency(null)                 // => "$0.00"
 * formatCurrency(null, { blank: "—" }) // => "—"
 * @remarks `blank` (default `"$0.00"`) is returned for null / undefined / empty
 * string / non-finite input. Accepts numeric strings.
 */
export function formatCurrency(amount?: string | number | null, opts: { blank?: string } = {}): string {
  const { blank = "$0.00" } = opts;
  if (amount == null || amount === "") return blank;
  const num = typeof amount === "string" ? parseFloat(amount) : amount;
  if (!Number.isFinite(num)) return blank;
  return USD.format(num);
}
